import { GooglemapComponent } from './features/map/googlemap/googlemap.component';
import { ChangestatedialogComponent } from './features/dialogs/changestatedialog/changestatedialog.component';
import { MismatchquestionsinsubmitComponent } from './features/ticket/mismatchquestionsinsubmit/mismatchquestionsinsubmit.component';
import { DisputequalityticketnotesComponent } from './features/ticket/disputequalityticketnotes/disputequalityticketnotes.component';
import { EvaluatequalityqueueComponent } from './features/qualityqueue/evaluatequalityqueue/evaluatequalityqueue.component';
import { AddqualitynotesComponent } from './features/ticket/addqualitynotes/addqualitynotes.component';
import { ViewtickethistoryComponent } from './features/ticket/viewtickethistory/viewtickethistory.component';
import { ViewticketnotesComponent } from './features/ticket/viewticketnotes/viewticketnotes.component';
import { NotificationToEmailComponent } from './features/notification/notificationtoemail/notificationtoemail.component';
import { NotificationDeliveryStatusComponent } from './features/notification/notificationdeliverystatus/notificationdeliverystatus.component';
import { SendFeedbackByRoleComponent } from './features/notification/sendfeedbackbyrole/sendfeedbackbyrole.component';

import { Logger } from './features/shared/logger.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from './app.shared';
import { AppRoutingModule } from './app-routing.module';
import { DxPieChartModule, DxChartModule, DxDataGridModule } from 'devextreme-angular';

import { DatePipe } from '@angular/common';
import { MyDialogComponent } from './features/package/my-dialog/my-dialog.component';
import { CreatePackageDialogComponent } from './features/package/create-package-dialog/create-package-dialog.component';
import { CreatePackageComponent } from './features/package/create-package/create-package.component';
import { ConfigurationService } from './features/shared/configuration.service';
import { LoginComponent } from './features/login/login.component';
import { HomeComponent } from './features/home/home.component';
import { UserService } from './features/shared/userService';
import { LocalStorage } from './features/shared/localstorage.service';
import { AuthGuardService, SignInService } from './features/shared/auth-guard.service';
import { TicketComponent } from './features/ticket/ticket.component';
import { TicketService } from './features/shared/ticketService';
import { PhoneNumberPipe } from './features/shared/phonePipe';
import { ViewPackageComponent } from './features/package/view-package/view-package.component';
import { PackageListComponent } from './features/package/package-list/package-list.component';
import { CreatePackageAttributesComponent } from './features/package/create-package-attributes/create-package-attributes.component';
import { CreateAttributeDialogComponent } from './features/package/create-attribute-dialog/create-attribute-dialog.component';
import { AddAttributevaluesDialogComponent } from './features/package/add-attributevalues-dialog/add-attributevalues-dialog.component';
import { CreateAttributeService } from './features/shared/createattribute.service';
import { AuthenticationService } from './features/shared/authentication.service';
import { QuestionService } from './features/shared/questionService';
import { QualityqueueComponent } from './features/qualityqueue/qualityqueue/qualityqueue.component';
import { QualityTicketService } from './features/shared/qualityticketqueue.service';
import {
  QATicketConfigComponent,
  AddQuestionDialogComponent,
  ConfirmQuestionDeleteComponent,
  AddMultiAnswerQuestionDialogComponent,
  AddAnswerDialogComponent
} from './features/ticket/qaticket-config.component';
import {
  AgentManagementComponent,
  ConfirmUpdateComponent,
  AgentSearchValidatorDirective
} from './features/agentmanagement/agent-management.component';
import { AgentService } from './features/agentmanagement/agent-management.service';
import { MapService } from './features/shared/map.service';
import { ViewTicketComponent } from './features/ticket/view ticket/viewticket.component';
import { ViewmyticketsComponent } from './features/qualityqueue/viewmytickets/viewmytickets.component';
import { QualityticketComponent } from './features/ticket/qualityticket/qualityticket.component';
import { QualityqueuedeferredComponent } from './features/qualityqueue/qualityqueuedeferred/qualityqueuedeferred.component';
import { ConfirmdialogComponent } from './features/dialogs/confirmdialog/confirmdialog.component';
import { MapComponent } from './features/map/map.component';
import { MapContainerComponent } from './features/mapcontainer/mapcontainer.component';
import { InfodialogComponent } from './features/dialogs/infodialog/infodialog.component';
import { MapdialogComponent } from './features/dialogs/mapdialog/mapdialog.component';
import { MapsketchdialogComponent } from './features/dialogs/mapsketchdialog/mapsketchdialog.component';
import { SketchbyxydialogComponent } from './features/dialogs/sketchbyxydialog/sketchbyxydialog.component';
import { SearchMapComponent } from './features/map/searchMap/searchMap.component';
import { SendfeedbackComponent } from './features/dialogs/sendfeedback/sendfeedback.component';
import { NotificationsService } from './features/notification/activenotifications/notifications.service';
import { ActiveNotificationsComponent } from './features/notification/activenotifications/activenotifications.component';
import { GetAllNotificationsByDateComponent } from './features/notification/getallnotificationsbydate/getallnotificationsbydate.component';
import { AddNotificationEmailComponent } from './features/notification/addnotificationemail/addnotificationemail.component';
import { QualityqueueexternalComponent } from './features/qualityqueue/qualityqueueexternal/qualityqueueexternal.component';
import { VieworaddqualitynotesComponent } from './features/ticket/vieworaddqualitynotes/vieworaddqualitynotes.component';
import { DisputedetailsComponent } from './features/ticket/disputedetails/disputedetails.component';
import { DisputedetailswithquestioninfoComponent } from './features/ticket/disputedetailswithquestioninfo/disputedetailswithquestioninfo.component';
import { ViewusersbyqualitygroupComponent } from './features/qualityqueue/viewusersbyqualitygroup/viewusersbyqualitygroup.component';
import { systemsettingsserviceService } from './features/shared/systemsettingsservice.service';
import { PacketDashboardComponent } from './features/report/packetDashboard/packetDashboard.component';
import { PacketComponent } from './features/report/packet/packet.component';
import { PacketDeductionsChartComponent } from './features/report/packet-deductions-chart/packet-deductions-chart.component';

@NgModule({
  declarations: [
    AppComponent,
    MyDialogComponent,
    CreatePackageDialogComponent,
    CreatePackageComponent,
    LoginComponent,
    HomeComponent,
    TicketComponent,
    PhoneNumberPipe,
    PackageListComponent,
    ViewPackageComponent,
    CreatePackageAttributesComponent,
    CreateAttributeDialogComponent,
    AddAttributevaluesDialogComponent,
    QualityqueueComponent,
    QATicketConfigComponent,
    AddQuestionDialogComponent,
    AgentManagementComponent,
    ConfirmUpdateComponent,
    ConfirmQuestionDeleteComponent,
    ViewTicketComponent,
    ViewmyticketsComponent,
    QualityticketComponent,
    QualityqueuedeferredComponent,
    ConfirmdialogComponent,
    MapComponent,
    MapContainerComponent,
    InfodialogComponent,
    AgentSearchValidatorDirective,
    MapdialogComponent,
    MapsketchdialogComponent,
    SketchbyxydialogComponent,
    SearchMapComponent,
    SendfeedbackComponent,
    ActiveNotificationsComponent,
    SendFeedbackByRoleComponent,
    GetAllNotificationsByDateComponent,
    NotificationDeliveryStatusComponent,
    NotificationToEmailComponent,
    AddNotificationEmailComponent,
    QualityqueueexternalComponent,
    AddAttributevaluesDialogComponent,
    AddMultiAnswerQuestionDialogComponent,
    AddAnswerDialogComponent,
    ViewticketnotesComponent,
    ViewtickethistoryComponent,
    AddqualitynotesComponent,
    VieworaddqualitynotesComponent,
    EvaluatequalityqueueComponent,
    DisputequalityticketnotesComponent,
    MismatchquestionsinsubmitComponent,
    DisputedetailsComponent,
    DisputedetailswithquestioninfoComponent,
    ViewusersbyqualitygroupComponent,
    ChangestatedialogComponent,
    PacketDashboardComponent,
    PacketComponent,
    PacketDeductionsChartComponent,
    GooglemapComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    DxPieChartModule,
    DxChartModule,
    DxDataGridModule,
  ],
  entryComponents: [
    MyDialogComponent,
    CreatePackageDialogComponent,
    CreateAttributeDialogComponent,
    AddAttributevaluesDialogComponent,
    AddQuestionDialogComponent,
    ConfirmUpdateComponent,
    ConfirmQuestionDeleteComponent,
    ConfirmdialogComponent,
    InfodialogComponent,
    MapdialogComponent,
    MapsketchdialogComponent,
    SketchbyxydialogComponent,
    SearchMapComponent,
    SendfeedbackComponent,
    ActiveNotificationsComponent,
    SendFeedbackByRoleComponent,
    GetAllNotificationsByDateComponent,
    NotificationDeliveryStatusComponent,
    NotificationToEmailComponent,
    AddNotificationEmailComponent,
    QualityqueueexternalComponent,
    AddMultiAnswerQuestionDialogComponent,
    AddAnswerDialogComponent,
    ViewticketnotesComponent,
    ViewtickethistoryComponent,
    AddqualitynotesComponent,
    VieworaddqualitynotesComponent,
    EvaluatequalityqueueComponent,
    DisputequalityticketnotesComponent,
    MismatchquestionsinsubmitComponent,
    DisputedetailsComponent,
    DisputedetailswithquestioninfoComponent,
    ViewusersbyqualitygroupComponent,
    ChangestatedialogComponent,
    GooglemapComponent
  ],
  providers: [
    ConfigurationService,
    UserService,
    LocalStorage,
    AuthGuardService,
    SignInService,
    TicketService,
    CreateAttributeService,
    AuthenticationService,
    QuestionService,
    QualityTicketService,
    AgentService,
    DatePipe,
    Logger,
    MapService,
    NotificationsService,
    systemsettingsserviceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
